// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCitationPing-cls1_m-V","cls2":"NewCitationPing-cls2_pHw NewCitationPing-cls1_m-V"};